import http from '@/axiosConfig'

const settingRoutes = {
  GET_COMPANY_EXTRA_PARAMS: 'dashboard/core/company/:companyCode/extra_params',
  GET_RESTRICTED_DRIVING_OPTIONS: 'dashboard/core/company/:companyCode/restricted_driving_options'
}

export default {
  replaceURLParams({url, companyCode}) {
    return url.replace(':companyCode', companyCode)
  },
  getFetch({url, companyCode, errorMessage = 'Error al consultar'}) {
    return new Promise((resolve) => {      
      http.get(this.replaceURLParams({url, companyCode}))
        .then(({ data }) => {
          resolve(data)
        })
        .catch(ex => {
          console.log(ex);
          toast.error(errorMessage);
        })
    })
  },
  getCompanyExtraParams({ companyCode }) {
    return this.getFetch({url: settingRoutes.GET_COMPANY_EXTRA_PARAMS, companyCode})
  },
  getRestrictedDrivingOptions({ companyCode }) {
    return this.getFetch({url: settingRoutes.GET_RESTRICTED_DRIVING_OPTIONS, companyCode})
  }
}
